import { render } from "./App.vue?vue&type=template&id=1fc2e9b0"
const script = {}

import "./App.vue?vue&type=style&index=0&id=1fc2e9b0&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__